import React, { useState, useEffect } from 'react';
import Layout from '../components/Layout';
import { faqsAPI } from '../services/api';

const FAQs = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    loadFAQs();
  }, []);

  const loadFAQs = async () => {
    try {
      const response = await faqsAPI.getAll();
      setFaqs(response.data);
    } catch (error) {
      console.error('Error loading FAQs:', error);
    } finally {
      setLoading(false);
    }
  };

  const filteredFaqs = faqs.filter((faq) => {
    if (!searchQuery.trim()) return true;
    const query = searchQuery.toLowerCase();
    return (
      faq.question.toLowerCase().includes(query) ||
      faq.answer.toLowerCase().includes(query) ||
      (faq.category && faq.category.toLowerCase().includes(query)) ||
      (faq.tags && faq.tags.toLowerCase().includes(query))
    );
  });

  if (loading) return <Layout><div>Loading...</div></Layout>;

  return (
    <Layout>
      <h2 style={{ marginBottom: '1.5rem' }}>Frequently Asked Questions</h2>

      {/* Search Box */}
      <div style={{ marginBottom: '1.5rem' }}>
        <input
          type="text"
          placeholder="Search FAQs..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{
            width: '100%',
            padding: '0.75rem 1rem',
            fontSize: '1rem',
            border: '2px solid #e0e0e0',
            borderRadius: '8px',
            boxSizing: 'border-box',
            transition: 'border-color 0.2s'
          }}
          onFocus={(e) => e.target.style.borderColor = '#4A90E2'}
          onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
        />
        {searchQuery && (
          <p style={{ margin: '0.5rem 0 0 0', fontSize: '0.9rem', color: '#666' }}>
            Found {filteredFaqs.length} result{filteredFaqs.length !== 1 ? 's' : ''}
          </p>
        )}
      </div>
      {faqs.length === 0 ? (
        <p>No FAQs available.</p>
      ) : filteredFaqs.length === 0 ? (
        <div style={{ background: 'white', padding: '2rem', borderRadius: '8px', border: '1px solid #ddd', textAlign: 'center' }}>
          <p style={{ color: '#666', margin: 0 }}>No FAQs match your search query.</p>
        </div>
      ) : (
        <div style={{ background: 'white', borderRadius: '8px', padding: '1rem', border: '1px solid #ddd' }}>
          {filteredFaqs.map((faq, index) => (
            <div key={faq.id} style={{ marginBottom: '1.5rem', paddingBottom: '1.5rem', borderBottom: index < filteredFaqs.length - 1 ? '1px solid #eee' : 'none' }}>
              <h3 style={{ margin: '0 0 0.75rem 0', color: '#2c3e50' }}>{faq.question}</h3>
              <p style={{ margin: 0, lineHeight: '1.6' }}>{faq.answer}</p>
              {faq.category && <span style={{ display: 'inline-block', marginTop: '0.5rem', padding: '0.25rem 0.75rem', background: '#ecf0f1', borderRadius: '12px', fontSize: '0.85rem' }}>{faq.category}</span>}
            </div>
          ))}
        </div>
      )}
    </Layout>
  );
};

export default FAQs;
